
import React, { useContext, Children, useState, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import BarCodeReader from '../ui-elements/BarCodeReader'



type Props = {
  setQuestionAnswer: any
  defaultValue: null | string | string[]
}

function QuestionBarCode({
  setQuestionAnswer,
  defaultValue
}: Props) {

  const {
    tableData
  } = useContext(GlobalContext)

  const [results, setResults] = useState<ScanResult | null>(null)

  useEffect(() => {
    if (results) {
      setQuestionAnswer(results.text)
    } else {
      setQuestionAnswer(null)
    }
  }, [results])

  return <div className={`w-full`}>


    <BarCodeReader
      results={results}
      setResults={setResults}
     />
 
  </div>
}
export default QuestionBarCode